// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-credit-page {
  padding: 40px 6.5%;
}
.post-credit-header h3 {
  color: var(--sebrae-gray);
  font-size: 24px;
  margin-bottom: 0;
}
.post-credit-header p {
  line-height: 23.3px;
  color: var(--sebrae-gray);
}
.post-credit-filter {
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}
.post-credit-filter h3 {
  flex: 1 1;
  min-width: 0;
}
.post-credit-filter .input-select-container {
  flex: 0 0 242px;
  width: 242px;
}
.post-credit-filter__select {
  width: 100%;
  max-width: 242px;
}
@media (max-width: 768px) {
  .post-credit-filter {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .post-credit-filter h3 {
    width: 100%;
  }
  .post-credit-filter .input-select-container {
    flex: 0 1;
    width: 100%;
    max-width: none;
  }
}

.planning-table {
  display: flex;
  gap: 10px;
  padding-top: 24px;
}
@media (max-width: 768px) {
  .planning-table {
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100%;
  }
}
.planning-table .plannings-list {
  display: flex;
  flex-direction: column;
  margin-top: 33px;
  flex-shrink: 0;
  min-width: 320px;
}
@media (max-width: 768px) {
  .planning-table .plannings-list {
    min-width: 240px;
  }
}
.planning-table .plannings-list .planning-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--sebrae-light-gray);
  width: 320px;
}
@media (max-width: 768px) {
  .planning-table .plannings-list .planning-item {
    width: 240px;
  }
}
.planning-table .plannings-list .planning-item:last-child {
  border-bottom: none;
}
.planning-table .plannings-list .planning-item img {
  cursor: pointer;
  transition: transform 0.3s ease, width 0.3s ease, height 0.3s ease;
}
.planning-table .plannings-list .planning-item-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 16px;
  margin: 8px 0;
  height: 88px;
  border-left: 2px solid transparent;
  transition: height 0.3s ease;
}
.planning-table .plannings-list .planning-item-content .new-badge {
  color: var(--sebrae-light-blue);
  font-size: 10px;
  line-height: 100%;
  font-weight: 400;
  opacity: 1;
  transition: opacity 0.2s ease, max-height 0.3s ease;
  max-height: 20px;
  overflow: hidden;
}
.planning-table .plannings-list .planning-item-content-name {
  font-size: 16px;
  font-weight: 700;
  line-height: 23.3px;
  color: var(--sebrae-gray);
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: underline;
  white-space: nowrap;
  cursor: pointer;
}
.planning-table .plannings-list .planning-item-content-name:hover {
  color: var(--sebrae-dark-gray2);
}
.planning-table .plannings-list .planning-item-content-date {
  font-size: 13px;
  font-weight: 400;
  line-height: 100%;
  color: var(--sebrae-gray);
  opacity: 1;
  transition: opacity 0.3s ease, max-height 0.3s ease;
  max-height: 20px;
  overflow: hidden;
  cursor: default;
}
.planning-table .plannings-list .planning-item-content-id {
  gap: 6px;
  display: inline-flex;
  align-items: center;
  width: fit-content;
  margin-top: 8px;
  padding: 4px 12px;
  border: 1px solid #8FB8EF;
  border-radius: 999px;
  background-color: var(--sebrae-white-3);
  color: var(--sebrae-blue-2);
  font-size: 12px;
  font-weight: 500;
  line-height: 100%;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.planning-table .plannings-list .planning-item-content-id:hover {
  background-color: var(--sebrae-white-1);
}
.planning-table .plannings-list .planning-item.closed img {
  transform: rotate(180deg);
}
.planning-table .plannings-list .planning-item.closed .planning-item-content {
  height: 32px;
  margin: 8px 0;
}
.planning-table .plannings-list .planning-item.closed .planning-item-content .new-badge,
.planning-table .plannings-list .planning-item.closed .planning-item-content .planning-item-content-date {
  opacity: 0;
  max-height: 0;
}
.planning-table .plannings-list .planning-item.closed .planning-item-content-name {
  font-size: 13px;
  line-height: 100%;
}
.planning-table .planning-content {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  overflow-x: auto;
}
@media (max-width: 768px) {
  .planning-table .planning-content {
    overflow: visible;
    flex-shrink: 0;
  }
}
.planning-table .planning-content .planning-months-grid {
  display: grid;
  grid-template-columns: repeat(150, 143px);
  justify-items: center;
  margin-top: 12px;
}
.planning-table .planning-content .planning-months-grid .planning-month {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--sebrae-light-gray);
  width: 100%;
  height: 21px;
  position: relative;
  border-left: 1px solid var(--sebrae-light-gray4);
}
.planning-table .planning-content .planning-months-grid .planning-month:first-child {
  border-left: none;
}
.planning-table .planning-content .planning-months-grid .planning-month .year {
  position: absolute;
  top: -36px;
  font-size: 16px;
  font-weight: 700;
  line-height: 23.3px;
  color: var(--sebrae-gray);
}
.planning-table .planning-content .planning-months-grid .planning-month .month-name {
  font-size: 11px;
  font-weight: 400;
  line-height: 100%;
  color: var(--sebrae-gray);
}
.planning-table .planning-content .planning-months-grid .current-month {
  background-color: #8FB8EF;
}
.planning-table .planning-content .planning-months-grid .current-month .month-name {
  color: var(--sebrae-white-3);
  font-weight: 700;
}
.planning-table .planning-content-cells {
  display: flex;
  flex-direction: column;
}
.planning-table .planning-content-cells .planning-row {
  display: grid;
  grid-template-columns: repeat(150, 143px);
  height: 89px;
  border-bottom: 1px solid var(--sebrae-light-gray);
  transition: height 0.3s ease;
}
.planning-table .planning-content-cells .planning-row:last-child {
  border-bottom: none;
}
.planning-table .planning-content-cells .planning-row .planning-cell {
  border-left: 1px solid var(--sebrae-light-gray);
  display: flex;
  align-items: center;
  justify-content: center;
}
.planning-table .planning-content-cells .planning-row .planning-cell:first-child {
  border-left: none;
}
.planning-table .planning-content-cells .planning-row .planning-cell > * {
  opacity: 1;
  transition: opacity 0.2s ease;
}
.planning-table .planning-content-cells .planning-row .current-month-cell {
  background-color: var(--sebrae-light-blue3);
}
.planning-table .planning-content-cells .planning-row.closed {
  height: 48px;
}
.planning-table .planning-content-cells .planning-row.closed .planning-cell > * {
  opacity: 0;
}
.planning-table .planning-content::-webkit-scrollbar {
  height: 10px;
}

.post-credit-button {
  position: relative;
  width: 135px;
  height: 42px;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}
.post-credit-button::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 8px;
  padding: 1px;
  background: var(--border-gradient, transparent);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
}
.post-credit-button-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.post-credit-button-text span {
  color: var(--sebrae-dark-blue);
  line-height: 100%;
}
.post-credit-button-text span:first-child {
  font-size: 11px;
  font-weight: 700;
}
.post-credit-button-text span:last-child {
  font-size: 8px;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/pages/post-credit/index.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;AAAJ;AAII;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AAFN;AAII;EACE,mBAAA;EACA,yBAAA;AAFN;AAME;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAJJ;AAMI;EACE,SAAA;EACA,YAAA;AAJN;AAOI;EACE,eAAA;EACA,YAAA;AALN;AAQI;EACE,WAAA;EACA,gBAAA;AANN;AAUE;EACE;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EARJ;EAUI;IACE,WAAA;EARN;EAWI;IACE,SAAA;IACA,WAAA;IACA,eAAA;EATN;AACF;;AAcA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AAXF;AAaE;EALF;IAMI,gBAAA;IACA,kBAAA;IACA,eAAA;EAVF;AACF;AAYE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAVJ;AAYI;EAPF;IAQI,gBAAA;EATJ;AACF;AAWI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iDAAA;EACA,YAAA;AATN;AAWM;EAPF;IAQI,YAAA;EARN;AACF;AAUM;EACE,mBAAA;AARR;AAWM;EACE,eAAA;EACA,kEAAA;AATR;AAYM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kCAAA;EACA,4BAAA;AAVR;AAYQ;EACE,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,mDAAA;EACA,gBAAA;EACA,gBAAA;AAVV;AAaQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;AAXV;AAaU;EACE,+BAAA;AAXZ;AAeQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,mDAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAbV;AAgBQ;EACE,QAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,uCAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,uDAAA;AAdV;AAgBU;EACE,uCAAA;AAdZ;AAoBQ;EACE,yBAAA;AAlBV;AAqBQ;EACE,YAAA;EACA,aAAA;AAnBV;AAqBU;;EAEE,UAAA;EACA,aAAA;AAnBZ;AAsBU;EACE,eAAA;EACA,iBAAA;AApBZ;AA2BE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAzBJ;AA2BI;EANF;IAOI,iBAAA;IACA,cAAA;EAxBJ;AACF;AA0BI;EACE,aAAA;EACA,yCAAA;EACA,qBAAA;EACA,gBAAA;AAxBN;AA0BM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gDAAA;AAxBR;AA0BQ;EACE,iBAAA;AAxBV;AA2BQ;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AAzBV;AA4BQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA1BV;AA8BM;EACE,yBAAA;AA5BR;AA8BQ;EACE,4BAAA;EACA,gBAAA;AA5BV;AAiCI;EACE,aAAA;EACA,sBAAA;AA/BN;AAiCM;EACE,aAAA;EACA,yCAAA;EACA,YAAA;EACA,iDAAA;EACA,4BAAA;AA/BR;AAiCQ;EACE,mBAAA;AA/BV;AAkCQ;EACE,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhCV;AAkCU;EACE,iBAAA;AAhCZ;AAmCU;EACE,UAAA;EACA,6BAAA;AAjCZ;AAqCQ;EACE,2CAAA;AAnCV;AAsCQ;EACE,YAAA;AApCV;AAsCU;EACE,UAAA;AApCZ;AA2CE;EACE,YAAA;AAzCJ;;AA6CA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AA3CF;AA6CE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,+CAAA;EACA,8EACE;EAGF,uBAAA;EACA,oBAAA;AA7CJ;AAgDE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AA9CJ;AAgDI;EACE,8BAAA;EACA,iBAAA;AA9CN;AAgDM;EACE,eAAA;EACA,gBAAA;AA9CR;AAiDM;EACE,cAAA;EACA,gBAAA;AA/CR","sourcesContent":[".post-credit {\n  &-page {\n    padding: 40px 6.5%;\n  }\n\n  &-header {\n    h3 {\n      color: var(--sebrae-gray);\n      font-size: 24px;\n      margin-bottom: 0;\n    }\n    p {\n      line-height: 23.3px;\n      color: var(--sebrae-gray);\n    }\n  }\n\n  &-filter {\n    display: flex;\n    margin-bottom: 16px;\n    align-items: center;\n    justify-content: space-between;\n    gap: 24px;\n\n    h3 {\n      flex: 1;\n      min-width: 0;\n    }\n\n    .input-select-container {\n      flex: 0 0 242px;\n      width: 242px;\n    }\n\n    &__select {\n      width: 100%;\n      max-width: 242px;\n    }\n  }\n\n  @media (max-width: 768px) {\n    &-filter {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 12px;\n\n      h3 {\n        width: 100%;\n      }\n\n      .input-select-container {\n        flex: 0;\n        width: 100%;\n        max-width: none;\n      }\n    }\n  }\n}\n\n.planning-table {\n  display: flex;\n  gap: 10px;\n  padding-top: 24px;\n\n  @media (max-width: 768px) {\n    overflow-x: auto;\n    overflow-y: hidden;\n    max-width: 100%;\n  }\n\n  .plannings-list {\n    display: flex;\n    flex-direction: column;\n    margin-top: 33px;\n    flex-shrink: 0;\n    min-width: 320px;\n\n    @media (max-width: 768px) {\n      min-width: 240px;\n    }\n\n    .planning-item {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      border-bottom: 1px solid var(--sebrae-light-gray);\n      width: 320px;\n      \n      @media (max-width: 768px) {\n        width: 240px;\n      }\n\n      &:last-child {\n        border-bottom: none;\n      }\n      \n      img {\n        cursor: pointer;\n        transition: transform 0.3s ease, width 0.3s ease, height 0.3s ease;\n      }\n\n      &-content {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        padding: 10px 16px;\n        margin: 8px 0;\n        height: 88px;\n        border-left: 2px solid transparent;\n        transition: height 0.3s ease;\n\n        .new-badge {\n          color: var(--sebrae-light-blue);\n          font-size: 10px;\n          line-height: 100%;\n          font-weight: 400;\n          opacity: 1;\n          transition: opacity 0.2s ease, max-height 0.3s ease;\n          max-height: 20px;\n          overflow: hidden;\n        }\n        \n        &-name {\n          font-size: 16px;\n          font-weight: 700;\n          line-height: 23.3px;\n          color: var(--sebrae-gray);\n          max-width: 250px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          text-decoration: underline;\n          white-space: nowrap;\n          cursor: pointer;\n\n          &:hover {\n            color: var(--sebrae-dark-gray2);\n          }\n        }\n        \n        &-date {\n          font-size: 13px;\n          font-weight: 400;\n          line-height: 100%;\n          color: var(--sebrae-gray);\n          opacity: 1;\n          transition: opacity 0.3s ease, max-height 0.3s ease;\n          max-height: 20px;\n          overflow: hidden;\n          cursor: default;\n        }\n\n        &-id {\n          gap: 6px;\n          display: inline-flex;\n          align-items: center;\n          width: fit-content;\n          margin-top: 8px;\n          padding: 4px 12px;\n          border: 1px solid #8FB8EF;\n          border-radius: 999px;\n          background-color: var(--sebrae-white-3);\n          color: var(--sebrae-blue-2);\n          font-size: 12px;\n          font-weight: 500;\n          line-height: 100%;\n          cursor: pointer;\n          transition: background-color 0.2s ease, color 0.2s ease;\n\n          &:hover {\n            background-color: var(--sebrae-white-1);\n          }\n        }\n      }\n\n      &.closed {\n        img {\n          transform: rotate(180deg);\n        }\n\n        .planning-item-content {\n          height: 32px;\n          margin: 8px 0;\n\n          .new-badge,\n          .planning-item-content-date {\n            opacity: 0;\n            max-height: 0;\n          }\n\n          &-name {\n            font-size: 13px;\n            line-height: 100%;\n          }\n        }\n      }\n    }\n  }\n\n  .planning-content {\n    display: flex;\n    flex-direction: column;\n    overflow-y: hidden;\n    overflow-x: auto;\n\n    @media (max-width: 768px) {\n      overflow: visible;\n      flex-shrink: 0;\n    }\n\n    .planning-months-grid {\n      display: grid;\n      grid-template-columns: repeat(150, 143px);\n      justify-items: center;\n      margin-top: 12px;\n  \n      .planning-month {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        background-color: var(--sebrae-light-gray);\n        width: 100%;\n        height: 21px;\n        position: relative;\n        border-left: 1px solid var(--sebrae-light-gray4);\n        \n        &:first-child {\n          border-left: none;\n        }\n  \n        .year {\n          position: absolute;\n          top: -36px;\n          font-size: 16px;\n          font-weight: 700;\n          line-height: 23.3px;\n          color: var(--sebrae-gray);\n        }\n  \n        .month-name {\n          font-size: 11px;\n          font-weight: 400;\n          line-height: 100%;\n          color: var(--sebrae-gray);\n        }\n      }\n  \n      .current-month {\n        background-color: #8FB8EF;\n        \n        .month-name {\n          color: var(--sebrae-white-3);\n          font-weight: 700;\n        }\n      }\n    }\n\n    &-cells {\n      display: flex;\n      flex-direction: column;\n\n      .planning-row {\n        display: grid;\n        grid-template-columns: repeat(150, 143px);\n        height: 89px;\n        border-bottom: 1px solid var(--sebrae-light-gray);\n        transition: height 0.3s ease;\n        \n        &:last-child {\n          border-bottom: none;\n        }\n        \n        .planning-cell {\n          border-left: 1px solid var(--sebrae-light-gray);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          \n          &:first-child {\n            border-left: none;\n          }\n\n          > * {\n            opacity: 1;\n            transition: opacity 0.2s ease;\n          }\n        }\n\n        .current-month-cell {\n          background-color: var(--sebrae-light-blue3);\n        }\n\n        &.closed {\n          height: 48px;\n\n          .planning-cell > * {\n            opacity: 0;\n          }\n        }\n      }\n    }\n  }\n\n  .planning-content::-webkit-scrollbar {\n    height: 10px;\n  }\n}\n\n.post-credit-button {\n  position: relative;\n  width: 135px;\n  height: 42px;\n  border-radius: 8px;\n  padding: 8px;\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border-radius: 8px;\n    padding: 1px;\n    background: var(--border-gradient, transparent);\n    -webkit-mask: \n      linear-gradient(#fff 0 0) content-box, \n      linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    pointer-events: none;\n  }\n\n  &-text {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n\n    span {\n      color: var(--sebrae-dark-blue);\n      line-height: 100%;\n\n      &:first-child {\n        font-size: 11px;\n        font-weight: 700;\n      }\n\n      &:last-child {\n        font-size: 8px;\n        font-weight: 400;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
